module.exports = __webpack_public_path__ + "img/badge.89a47e60.svg";